import { render, staticRenderFns } from "./backTagManage.vue?vue&type=template&id=649a965f&scoped=true"
import script from "./backTagManage.vue?vue&type=script&lang=js"
export * from "./backTagManage.vue?vue&type=script&lang=js"
import style0 from "./backTagManage.vue?vue&type=style&index=0&id=649a965f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a965f",
  null
  
)

export default component.exports